import { SearchApi } from "./axios-config";
import { FilterCriteria } from "data/@types/GlobalSearchData";
import { SortingOrder } from "utils/sort";

const ALL_DOCUMENT_TYPES = [
  "FIRM",
  "PRODUCT_STRATEGY",
  "COMMENT",
  "MEETING",
  "RATING_CHANGE",
  "ISSUE_SHEET",
];

const createSearchQuery = (
  searchPhrase: string,
  sortOrder: SortingOrder,
  filters?: FilterCriteria,
  documentTypes?: string[],
) => ({
  items: (documentTypes ?? ALL_DOCUMENT_TYPES).map((documentType) => ({
    documentType,
    sortOrder,
  })),
  searchPhrase: searchPhrase,
  filters: filters,
});

const globalSearchQuery = async (
  text: string,
  sortOrder: SortingOrder = "desc",
  filters?: FilterCriteria,
  documentTypes?: string[],
) => {
  return SearchApi.post(
    "/query",
    createSearchQuery(text, sortOrder, filters, documentTypes),
  );
};

const globalSearchList = async (
  documentType: string,
  sortOrder: SortingOrder = "desc",
  filters?: FilterCriteria,
) => {
  return SearchApi.post("/list", {
    items: [{ documentType: documentType, sortOrder: sortOrder }],
    filters,
  });
};

export { globalSearchQuery, globalSearchList };
